import request from '@/utils/request'
import URL from '../urlTranslator'

// 查询全部已启用的
export function queryAllActive() {
  return request({
    url: URL.mdm.innerContractNo.queryAllActive,
    method: 'get'
  })
}

// 查询
export function query(params) {
  return request({
    url: URL.mdm.innerContractNo.query,
    method: 'get',
    params
  })
}

// 保存
export function save(data) {
  return request({
    url: URL.mdm.innerContractNo.save,
    method: 'post',
    data
  })
}

// 批量启用/禁用
export function batchUpdateActive(keys, active) {
  return request({
    url: URL.mdm.innerContractNo.batchUpdateActive,
    method: 'post',
    data: keys,
    params: { active }
  })
}

// 批量删除
export function batchDelete(keys) {
  return request({
    url: URL.mdm.innerContractNo.batchDelete,
    method: 'delete',
    data: keys
  })
}
